module.exports = __webpack_public_path__ + "static/media/logo-login.aee1d892.png";